import { useState } from 'react';
import { useLazyGetCourierDeliveryExpectedTimeQuery } from '../../../../redux/APIs/productApi';



const CheckPincode = () => {
  const [pinCode, setPinCode] = useState('');
  const [getCourierDeliveryTime, { data: deliveryTimeData, error, isLoading }] = useLazyGetCourierDeliveryExpectedTimeQuery();

  const handlePinChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === '' || /^[0-9]{0,6}$/.test(inputValue)) {
      setPinCode(inputValue);
    }
  };

  const handleBlur = () => {
    if (pinCode.length !== 6) {
      setPinCode('');
    }
  };

  const handleCheckPincode = async () => {
    if (pinCode.length === 6) {
      const res = await getCourierDeliveryTime(pinCode);
      console.log('Pincode Check Response:', res);
    }
  };

  return (
    <div className="pincode-check-container">
      <input
        type="text"
        value={pinCode}
        onChange={handlePinChange}
        onBlur={handleBlur}
        placeholder="Enter Pincode"
        maxLength={6}
      />
      <button onClick={handleCheckPincode} disabled={isLoading}>
        {isLoading ? 'Checking...' : 'Check'}
      </button>
      {deliveryTimeData && <p>Expected Delivery by {deliveryTimeData.estimated_delivery_date}</p>}
      {error && <p className="error">Error checking pincode</p>}
    </div>
  );
};

export default CheckPincode;
